<template>
  <div></div>
</template>

<script>
export default {
  name: "ValidatorMixin",
  methods: {
    inputValidator(text, type, validator = undefined) {
      let isValid = false;
      switch (type) {
        case "text":
          isValid = this.textValidator(text);
          break;
        case "password":
          isValid = this.passwordValidator(text);
          break;
        case "email":
          isValid = this.emailValidator(text);
          break;
        case "description":
          isValid = this.descriptionValidator(text);
          break;
        case "latitude":
          isValid = this.coordinatesValidator(text);
          break;
        case "longitude":
          isValid = this.coordinatesValidator(text);
          break;
        case "custom":
          isValid = this.customValidator(text, validator);
          break;
        default:
          isValid = true;
          break;
      }
      return isValid;
    },
    textValidator(text) {
      return text.length >= 0;
    },
    passwordValidator(text) {
      return text.length >= 0;
    },
    emailValidator(text) {
      return text.length >= 0;
    },
    descriptionValidator(text) {
      return text.length >= 0;
    },
    customValidator(text, validator) {
      return text.length >= 0 && validator;
    }
  }
};
</script>
